export enum TransferTripType {
  ArrivalOnlyTrip = 1,
  DepartureOnlyTrip = 2,
  RoundTrip = 3,
}
